export default __webpack_public_path__ + "static/media/vikramaditya.6371c46d.png";